import classNames from 'clsx';
import React from 'react';

import { useOnboardingContext } from '@swf/components/Onboarding/OnboardingContext/OnbordingContext';

// TODO refactor to use composition or shared.scss
// eslint-disable-next-line no-restricted-imports
import styles from '../WalletHomeContainer/WalletHomeContainer.scss';
import { CashierOnboardingStep } from '../WalletHomeContainer/cashierOnboardingStepsInfo';

const WalletButtonGroup: React.FC<React.PropsWithChildren> = ({ children }) => {
  const { setFlowToStep, activeStep, onboardingFinished } = useOnboardingContext();

  return (
    <div
      className={classNames(styles.rightContainer, {
        [styles.activeStepTour]:
          !onboardingFinished && activeStep === CashierOnboardingStep.StepCashierPanel
      })}
      ref={
        !onboardingFinished && setFlowToStep
          ? setFlowToStep(CashierOnboardingStep.StepCashierPanel)
          : null
      }
    >
      {children}
    </div>
  );
};
export default WalletButtonGroup;
